<template>
  <div class="result-view">
    <div class="main-section">
      <div
        class="nav"
        style="width: 100%; height: 50px; line-height: 50px; text-align: center"
      >
        <h2 class="btn-back">
          <span
            class="back"
            style="
              position: absolute;
              left: 3%;
              cursor: pointer;
              color: #ffc2ac;
            "
            v-on:click="backToHistory()"
            >&lt;&nbsp;&nbsp;返回
          </span>
        </h2>
      </div>
      <div class="section-card-img section-1">
        <div class="section-1-title"></div>
        <div class="section-1-content">
          <div class="section-1-content-inner-1">
            <h3 class="username text-c-1">
              <span data-name="name">{{ result.name }}</span> /
              <span data-name="gender">{{
                result.gender == 1 ? '男' : '女'
              }}</span>
            </h3>
            <p class="paragraph text-c-2 text-bolder">
              阳历
              <span class="time text-preview-data text-c-1">{{
                getMoment(result.birthday).year()
              }}</span>
              年
              <span class="time text-preview-data text-c-1">{{
                getMoment(result.birthday).month() + 1
              }}</span>
              月
              <span class="time text-preview-data text-c-1">{{
                getMoment(result.birthday).date()
              }}</span>
              日
            </p>
            <p class="paragraph text-c-2 text-bolder">
              农历
              <span class="text-preview-data text-c-1">
                {{ result.lunarBirthday.year }}
              </span>
              年
              <span class="text-preview-data text-c-1">
                {{ result.lunarBirthday.month }}
              </span>
              月
              <span class="text-preview-data text-c-1">
                {{ result.lunarBirthday.day }}
              </span>
              日
            </p>
            <p class="paragraph text-bolder">
              <span class="text-preview-data text-c-1">
                {{ getSolarHour(getMoment(result.birthday).hour()) }}
                {{ result.lunarBirthday.shiChen }}时
              </span>
            </p>
          </div>
          <div class="section-1-content-inner-hr"></div>
          <div class="section-1-content-inner-1">
            <h6 class="paragraph text-c-1">订单编号 {{ orderNo }}</h6>
            <h6 class="paragraph text-c-1">{{ result.keyPrompt }}</h6>
          </div>
        </div>
        <div class="section-1-footer"></div>
      </div>
      <div class="section-2">
        <div class="result-navbar">
          <div class="result-navbar-left" v-on:click="toggleTag()">
            <img
              class="result-navbar-left-active"
              src="@/assets/image/year26-qz/left-active.webp"
              alt="重点提示"
              v-show="activeLeft"
            />
            <img
              class="result-navbar-left-inactive"
              src="@/assets/image/year26-qz/left.webp"
              alt="重点提示"
              v-show="!activeLeft"
            />
          </div>
          <div class="result-navbar-right" v-on:click="toggleTag()">
            <img
              class="result-navbar-right-active"
              src="@/assets/image/year26-qz/right-active.webp"
              alt="流月"
              v-show="!activeLeft"
            />
            <img
              class="result-navbar-right-inactive"
              src="@/assets/image/year26-qz/right.webp"
              alt="流月"
              v-show="activeLeft"
            />
          </div>
        </div>
        <div class="result-content-main" v-show="activeLeft">
          <!-- 事业 -->
          <div class="result-content-main-item">
            <div
              class="result-content-main-item-title result-content-work"
            ></div>
            <div class="result-content-main-item-content">
              <div class="result-content-main-item-content-inner-1">
                <p class="paragraph text-left text-c-1">
                  <span v-html="result.work"></span>
                </p>
              </div>
              <div class="result-content-main-item-content-inner-hr"></div>
              <div class="result-content-main-item-content-inner-2">
                <h4 class="key-month-title text-c-1 text-bolder">关键月份</h4>
                <div class="key-month-content">
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/work-up.png"
                        alt="强运"
                      />
                      <span>强运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.work.high.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.work.high.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.work.high.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.work.high.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.work.high.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.work.high.desc }}
                    </div>
                  </div>
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/work-down.png"
                        alt="低运"
                      />
                      <span>低运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.work.low.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.work.low.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.work.low.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.work.low.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.work.low.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.work.low.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="result-content-main-item-footer"></div>
          </div>
          <!-- 感情 -->
          <div class="result-content-main-item">
            <div
              class="result-content-main-item-title result-content-love"
            ></div>
            <div class="result-content-main-item-content">
              <div class="result-content-main-item-content-inner-1">
                <p class="paragraph text-left text-c-1">
                  <span v-html="result.relationship"></span>
                </p>
              </div>
              <div class="result-content-main-item-content-inner-hr"></div>
              <div class="result-content-main-item-content-inner-2">
                <h4 class="key-month-title text-c-1 text-bolder">关键月份</h4>
                <div class="key-month-content">
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/love-up.png"
                        alt="强运"
                      />
                      <span>强运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.love.high.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.love.high.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.love.high.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.love.high.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.love.high.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.love.high.desc }}
                    </div>
                  </div>
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/love-down.png"
                        alt="低运"
                      />
                      <span>低运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.love.low.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.love.low.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.love.low.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.love.low.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.love.low.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.love.low.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="result-content-main-item-footer"></div>
          </div>
          <!-- 财运 -->
          <div class="result-content-main-item">
            <div
              class="result-content-main-item-title result-content-money"
            ></div>
            <div class="result-content-main-item-content">
              <div class="result-content-main-item-content-inner-1">
                <p class="paragraph text-left text-c-1">
                  <span v-html="result.money"></span>
                </p>
              </div>
              <div class="result-content-main-item-content-inner-hr"></div>
              <div class="result-content-main-item-content-inner-2">
                <h4 class="key-month-title text-c-1 text-bolder">关键月份</h4>
                <div class="key-month-content">
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/money-up.png"
                        alt="强运"
                      />
                      <span>强运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.money.high.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.money.high.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.money.high.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.money.high.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.money.high.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.money.high.desc }}
                    </div>
                  </div>
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/money-down.png"
                        alt="低运"
                      />
                      <span>低运月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.money.low.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.money.low.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.money.low.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.money.low.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.money.low.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.money.low.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="result-content-main-item-footer"></div>
          </div>
          <!-- 健康 -->
          <div class="result-content-main-item" style="padding-bottom: 0">
            <div
              class="result-content-main-item-title result-content-health"
            ></div>
            <div class="result-content-main-item-content">
              <div class="result-content-main-item-content-inner-1">
                <p class="paragraph text-left text-c-1">
                  <span v-html="result.health"></span>
                </p>
              </div>
              <div class="result-content-main-item-content-inner-hr"></div>
              <div class="result-content-main-item-content-inner-2">
                <h4 class="key-month-title text-c-1 text-bolder">关键月份</h4>
                <div class="key-month-content">
                  <div class="key-month">
                    <div class="key-month-header text-c-1 text-bolder">
                      <img
                        src="@/assets/image/year26-qz/health-down.png"
                        alt="重点月份"
                      />
                      <span>重点月份</span>
                    </div>
                    <div class="key-month-date text-c-1 text-bolder">
                      <p class="">
                        农历 {{ result.keyMonth.health.low.month }} 月<br />
                        阳历
                        {{
                          result.keyMonth.health.low.startSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.health.low.startSolarDate.slice(6, 8)
                        }}
                        -
                        {{
                          result.keyMonth.health.low.endSolarDate.slice(4, 6)
                        }}/{{
                          result.keyMonth.health.low.endSolarDate.slice(6, 8)
                        }}
                      </p>
                    </div>
                    <div class="key-month-desc text-c-4">
                      {{ result.keyMonth.health.low.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="result-content-main-item-footer"></div>
          </div>
        </div>
        <div class="result-content-month" v-show="!activeLeft">
          <!-- ---------------------- -->
          <div class="accordion">
            <div
              class="accordion-item card"
              v-for="(value, index) in result.future"
              :key="index"
            >
              <input type="checkbox" :id="monthlyId(value.lunarMonth)" />
              <label
                :for="monthlyId(value.lunarMonth)"
                class="accordion-item-title text-c-5"
              >
                <h3 class="heading3">农历{{ value.lunarMonth }}月</h3>
                <h6 class="heading6">
                  阳历 {{ value.startSolarDate.substring(4, 6) }}/{{
                    value.startSolarDate.substring(6)
                  }}
                  - {{ value.endSolarDate.substring(4, 6) }}/{{
                    value.endSolarDate.substring(6)
                  }}
                </h6>
                <span class="icon i-plus"
                  ><img src="@/assets/image/year26-qz/plus.png" alt="plus"
                /></span>
                <span class="icon i-minus"
                  ><img src="@/assets/image/year26-qz/minus.png" alt="minus"
                /></span>
              </label>
              <div class="accordion-item-desc">
                <div class="accordion-item-desc-title"></div>
                <div class="accordion-item-desc-content">
                  <div class="desc-item-wrapper">
                    <div class="desc-item-header"></div>
                    <div class="desc-item">
                      <div class="desc-item-title">
                        <div class="desc-item-title-icon bg-work">
                          <img
                            src="@/assets/image/year26-qz/work.png"
                            alt="work"
                          />
                        </div>
                        <h4 class="score-title text-c-1 text-bolder">
                          工作指数
                        </h4>
                        <div class="starbox">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-fill"
                            viewBox="0 0 16 16"
                            v-for="(item, index) in Math.floor(value.workScore)"
                            :key="index"
                          >
                            <path
                              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-half"
                            viewBox="0 0 16 16"
                            v-if="value.workScore % 1 != 0"
                          >
                            <path
                              d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="desc-item-content">
                        <p class="desc-item-keyword text-c-1 text-bolder">
                          {{ value.workExplain.keyword.join('；') }}
                        </p>
                        <p class="desc-item-main text-c-1">
                          <span v-if="value.workExplain.main.length < 1"
                            >您本月在事业方面没有吉星辅助，低调行事，韬光养晦，广结善缘，为下一步打稳基石。<br
                          /></span>
                          <span v-else>
                            <span
                              v-for="(str, index) in value.workExplain.main"
                              :key="index"
                              >{{ str }}</span
                            >
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="desc-item-footer"></div>
                  </div>
                  <div class="desc-item-wrapper">
                    <div class="desc-item-header"></div>
                    <div class="desc-item">
                      <div class="desc-item-title">
                        <div class="desc-item-title-icon bg-love">
                          <img
                            src="@/assets/image/year26-qz/love.png"
                            alt="love"
                          />
                        </div>
                        <h4 class="score-title text-c-1 text-bolder">
                          感情指数
                        </h4>
                        <div class="starbox">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-fill"
                            viewBox="0 0 16 16"
                            v-for="(item, index) in Math.floor(value.loveScore)"
                            :key="index"
                          >
                            <path
                              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-half"
                            viewBox="0 0 16 16"
                            v-if="value.loveScore % 1 != 0"
                          >
                            <path
                              d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="desc-item-content">
                        <p class="desc-item-keyword text-c-1 text-bolder">
                          {{ value.loveExplain.keyword.join('；') }}
                        </p>
                        <p class="desc-item-main text-c-1">
                          <span v-if="value.loveExplain.main.length < 1"
                            >您本月在感情方面缺乏吉星的助力，正是好好修炼自我，调整心态的月份，把自己整理好，幸福来敲门时才能好好迎接喔。<br
                          /></span>
                          <span v-else>
                            <span
                              v-for="(str, index) in value.loveExplain.main"
                              :key="index"
                              >{{ str }}</span
                            >
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="desc-item-footer"></div>
                  </div>
                  <div class="desc-item-wrapper">
                    <div class="desc-item-header"></div>
                    <div class="desc-item">
                      <div class="desc-item-title">
                        <div class="desc-item-title-icon bg-wealth">
                          <img
                            src="@/assets/image/year26-qz/money.png"
                            alt="money"
                          />
                        </div>
                        <h4 class="score-title text-c-1 text-bolder">
                          财运手气
                        </h4>
                        <div class="starbox">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-fill"
                            viewBox="0 0 16 16"
                            v-for="(item, index) in Math.floor(
                              value.moneyScore
                            )"
                            :key="index"
                          >
                            <path
                              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-half"
                            viewBox="0 0 16 16"
                            v-if="value.moneyScore % 1 != 0"
                          >
                            <path
                              d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="desc-item-content">
                        <p class="desc-item-keyword text-c-1 text-bolder">
                          {{ value.moneyExplain.keyword.join('；') }}
                        </p>
                        <p class="desc-item-main text-c-1">
                          <span v-if="value.moneyExplain.main.length < 1"
                            >您本月在财运方面没有吉星照耀，理财宜保守谨慎，三思而行，做好财务规划，不要过度消费。<br
                          /></span>
                          <span v-else>
                            <span
                              v-for="(str, index) in value.moneyExplain.main"
                              :key="index"
                              >{{ str }}</span
                            >
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="desc-item-footer"></div>
                  </div>
                  <div class="desc-item-wrapper">
                    <div class="desc-item-header"></div>
                    <div class="desc-item">
                      <div class="desc-item-title">
                        <div class="desc-item-title-icon bg-health">
                          <img
                            src="@/assets/image/year26-qz/health.png"
                            alt="health"
                          />
                        </div>
                        <h4 class="score-title text-c-1 text-bolder">
                          健康状况
                        </h4>
                        <div class="starbox">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-fill"
                            viewBox="0 0 16 16"
                            v-for="(item, index) in Math.floor(
                              value.healthyScore
                            )"
                            :key="index"
                          >
                            <path
                              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#F6D365"
                            class="bi bi-star-half"
                            viewBox="0 0 16 16"
                            v-if="value.healthyScore % 1 != 0"
                          >
                            <path
                              d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="desc-item-content">
                        <p class="desc-item-keyword text-c-1 text-bolder">
                          {{ value.healthyExplain.keyword.join('；') }}
                        </p>
                        <p class="desc-item-main text-c-1">
                          <span v-if="value.healthyExplain.main.length < 1"
                            >您本月在健康方面缺乏吉星的保护，要保持正常作息，维持运动习惯，少吃辛辣，多喝水，勿熬夜，这些都是常保健康的金科玉律，要多注意就会养成好习惯。<br
                          /></span>
                          <span v-else>
                            <span
                              v-for="(str, index) in value.healthyExplain.main"
                              :key="index"
                              >{{ str }}</span
                            >
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="desc-item-footer"></div>
                  </div>
                </div>
                <div class="accordion-item-desc-footer"></div>
              </div>
            </div>
          </div>
          <!-- ---------------------- -->
        </div>
        <div class="result-navbar">
          <div class="result-navbar-left" @click="toggleTag()">
            <img
              class="result-navbar-left-active"
              src="@/assets/image/year26-qz/left-active.webp"
              alt="重点提示"
              v-show="activeLeft"
            />
            <img
              class="result-navbar-left-inactive"
              src="@/assets/image/year26-qz/left.webp"
              alt="重点提示"
              v-show="!activeLeft"
            />
          </div>
          <div class="result-navbar-right" @click="toggleTag()">
            <img
              class="result-navbar-right-active"
              src="@/assets/image/year26-qz/right-active.webp"
              alt="流月"
              v-show="!activeLeft"
            />
            <img
              class="result-navbar-right-inactive"
              src="@/assets/image/year26-qz/right.webp"
              alt="流月"
              v-show="activeLeft"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import moment from 'moment-timezone'

import { mapGetters } from 'vuex'
import { SHI_CHEN } from '@/constants/shi-chen-list'

export default {
  name: 'ResultView',
  data() {
    return {
      result: null,
      activeLeft: true,
    }
  },
  async beforeRouteEnter(to, from, next) {
    if (!store.getters.isLogin) {
      let res = await store.dispatch('login', {
        ...to.query,
        path: to.path,
        channel: store.state.fortune.channel,
      })
      if (!res) {
        next({ name: 'Home' })
      }
    }

    if (
      'undefined' === typeof store.getters['fortune/search'](to.params.orderNo)
    ) {
      var payload = {
        ttxid: store.state.user.ttxid,
        token: store.state.user.token,
        timestamp: store.state.user.timestamp,
        orderNo: to.params.orderNo,
      }
      store.dispatch('fortune/getResult', payload).then(
        () => {
          next()
        },
        (err) => {
          alert('尚未支付')
          next({ name: 'Home' })
        }
      )
    } else {
      next()
    }
  },
  created: function () {
    this.result = { ...this.search(this.$route.params.orderNo) }
    this.result.lowMonth =
      this.result.future &&
      this.result.future.reduce(
        (lowFuture, future) =>
          future.level < lowFuture.level ? future : lowFuture,
        this.result.future[0]
      )
  },
  mounted: function () {
    document.documentElement.scrollTop = 0
    // 设定第一个 accordion 为 checked
    this.$nextTick(() => {
      const accordion1 = document.getElementById('accordion1')
      if (accordion1) {
        accordion1.checked = true
      }
    })
  },
  methods: {
    backToHistory: function () {
      this.$router.push({ name: 'History' })
    },
    getMoment: function (timeString) {
      return moment.tz(timeString, 'YYYYMMDDHH', 'Etc/GMT-8')
    },
    getSolarHour: function (hour) {
      let str
      if (0 === hour || 23 === hour) {
        str = hour + ':00 ~ ' + hour + ':59'
      } else {
        str = hour + ':00 ~ ' + (hour + 1) + ':59'
      }
      return str
    },
    getLunarHour: function (hour) {
      if (hour !== 0 && hour % 2 === 0) {
        hour--
      }
      return SHI_CHEN[hour]
    },
    formatDateRange: function (dateRange) {
      if (Array.isArray(dateRange)) {
        return [...dateRange].reverse().map(this.formatDateRange).join(', ')
      }
      return `${moment(dateRange.startSolarDate, 'YYYYMMDD').format(
        'MM/DD'
      )} - ${moment(dateRange.endSolarDate, 'YYYYMMDD').format('MM/DD')}`
    },
    monthlyId: function (month) {
      return 'accordion' + month
    },
    toggleTag: function () {
      this.activeLeft = !this.activeLeft
    },
  },
  computed: {
    ...mapGetters('fortune', {
      search: 'search',
      isLoading: 'isLoading',
    }),
    orderNo: function () {
      return this.$route.params.orderNo
    },
  },
}
</script>

<style scoped>
body {
  background-color: #000;
}

.main-section {
  max-width: 750px;
  margin: 0 auto;
  background-color: #8f0303;
  background-image: url('../assets/image/year26-qz/smoke1.webp'),
    url('../assets/image/year26-qz/smoke2.webp'),
    url('../assets/image/year26-qz/smoke3.webp'),
    url('../assets/image/year26-qz/smoke4.webp');
  background-size: calc(750 / 750 * 100%), calc(748 / 750 * 100%),
    calc(750 / 750 * 100%), calc(748 / 750 * 100%);
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top 90vh left, top 180vh right, top 270vh right,
    top 360vh left;
}
.section-1 {
  padding-top: 3%;
  background-image: url('../assets/image/year26-qz/fireworks.webp');
  background-size: calc(89 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top right;
}
.section-2 {
  padding-bottom: 20px;
}
.section-1-title {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/title.webp'),
    url('../assets/image/year26-qz/frame-inner-1.webp'),
    url('../assets/image/year26-qz/frame-1.webp');
  background-size: calc(308 / 375 * 100%), calc(269 / 375 * 100%),
    calc(331 / 375 * 100%);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: top center, top 125% center, top 250% center;
  aspect-ratio: 375 / 80;
}
.section-1-content {
  width: 100%;
  margin: -1px 0;
  padding: 0;
  text-align: center;
  background-image: url('../assets/image/year26-qz/frame-2.webp');
  background-size: calc(331 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
}
.section-1-content-inner-1 {
  background-image: url('../assets/image/year26-qz/frame-inner-2.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
  padding: 0 20%;
}
.section-1-content-inner-hr {
  aspect-ratio: 375 / 30;
  background-image: url('../assets/image/year26-qz/frame-inner-hr.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: center;
}
.section-1-content-inner-2 {
  background-image: url('../assets/image/year26-qz/frame-inner-2.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
}
.price {
  background-image: url('../assets/image/year26-qz/price.webp');
  background-size: calc(238 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top center;
  aspect-ratio: 375 / 95;
  display: flex;
  justify-content: center;
  align-items: center;
}
.price-content {
  padding: 2% 0 0;
}
.discount {
  font-size: 16px;
}
.original-price {
  font-size: 14px;
  text-decoration: line-through;
  padding-left: 10px;
}

.countdown {
}
.btn-payment-img {
  padding: 5% 0;
}

.section-1-footer {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-inner-3.webp'),
    url('../assets/image/year26-qz/frame-3.webp');
  background-size: calc(269 / 375 * 100%), calc(331 / 375 * 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: bottom 100% center, bottom center;
  aspect-ratio: 375 / 65;
}

.result-navbar {
  display: flex;
  gap: 2%;
  justify-content: center;
  margin: 20px 5%;
}

.result-navbar img {
  width: 100%;
}

.result-navbar-left {
  flex: 1;
}
.result-navbar-right {
  flex: 1;
}

/* .result-navbar-left-active {
  display: block;
}
.result-navbar-left-inactive {
  display: none;
}
.result-navbar-right-active {
  display: none;
}
.result-navbar-right-inactive {
  display: block;
} */

.result-content-main-item {
  margin: 25px 0;
  padding-top: 3%;
  padding-bottom: 25px;
  background-image: url('../assets/image/year26-qz/fireworks.webp');
  background-size: calc(89 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top right;
}

.result-content-main-item-title {
  width: 100%;
  margin: 0;
  padding: 0;
  background-size: calc(308 / 375 * 100%), calc(269 / 375 * 100%),
    calc(331 / 375 * 100%);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: top center, top 125% center, top 250% center;
  aspect-ratio: 375 / 80;
}
.result-content-work {
  background-image: url('../assets/image/year26-qz/work-title.webp'),
    url('../assets/image/year26-qz/frame-inner-1.webp'),
    url('../assets/image/year26-qz/frame-1.webp');
}

.result-content-love {
  background-image: url('../assets/image/year26-qz/love-title.webp'),
    url('../assets/image/year26-qz/frame-inner-1.webp'),
    url('../assets/image/year26-qz/frame-1.webp');
}

.result-content-money {
  background-image: url('../assets/image/year26-qz/money-title.webp'),
    url('../assets/image/year26-qz/frame-inner-1.webp'),
    url('../assets/image/year26-qz/frame-1.webp');
}

.result-content-health {
  background-image: url('../assets/image/year26-qz/health-title.webp'),
    url('../assets/image/year26-qz/frame-inner-1.webp'),
    url('../assets/image/year26-qz/frame-1.webp');
}

.result-content-main-item-content {
  width: 100%;
  margin: -1px 0;
  padding: 0;
  text-align: center;
  background-image: url('../assets/image/year26-qz/frame-2.webp');
  background-size: calc(331 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
}
.result-content-main-item-content-inner-1 {
  background-image: url('../assets/image/year26-qz/frame-inner-2.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
  padding: 0 20%;
}
.result-content-main-item-content-inner-hr {
  aspect-ratio: 375 / 30;
  background-image: url('../assets/image/year26-qz/frame-inner-hr.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: center;
}

.result-content-main-item-content-inner-2 {
  background-image: url('../assets/image/year26-qz/frame-inner-2.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
  padding: 0 20%;
}

.key-month {
  padding: 20px 0;
}

.key-month-title {
  text-align: center;
  font-size: 20px;
}
.key-month-header {
  display: flex;
  margin: 15px 0;
  font-size: 18px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.key-month-header img {
  height: 30px;
}

.key-month-date {
  text-align: left;
  line-height: 1.75;
  font-size: 16px;
  margin: 20px 0;
}

.key-month-desc {
  text-align: left;
  line-height: 1.75;
  font-size: 16px;
}
.result-content-main-item-footer {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-inner-3.webp'),
    url('../assets/image/year26-qz/frame-3.webp');
  background-size: calc(269 / 375 * 100%), calc(331 / 375 * 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: bottom 100% center, bottom center;
  aspect-ratio: 375 / 65;
}

.accordion-item-title {
  width: 100%;
  margin: 0;
  padding: 0 20%;
  background-image: url('../assets/image/year26-qz/empty-title.webp');
  background-size: calc(308 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top center;
  aspect-ratio: 375 / 48;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
}

.accordion-item-desc {
  display: none;
}

.i-plus {
  display: block;
}
.i-minus {
  display: none;
}

.accordion-item input[type='checkbox']:checked ~ .accordion-item-desc {
  display: block;
}

.accordion-item input[type='checkbox']:checked ~ .accordion-item-title .i-plus {
  display: none;
}
.accordion-item
  input[type='checkbox']:checked
  ~ .accordion-item-title
  .i-minus {
  display: block;
}

.accordion-item-desc-title {
  width: 100%;
  margin: -6% 0 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-1.webp');
  background-size: calc(331 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top center;
  aspect-ratio: 375 / 45;
}

.accordion-item-desc-content {
  width: 100%;
  margin: -1px 0;
  padding: 0;
  text-align: center;
  background-image: url('../assets/image/year26-qz/frame-2.webp');
  background-size: calc(331 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.desc-item-header {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-inner-1.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: top center;
  aspect-ratio: 375 / 20;
}

.desc-item {
  background-image: url('../assets/image/year26-qz/frame-inner-2.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: repeat-y;
  background-position: top center;
  padding: 0 20%;
}
.desc-item-footer {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-inner-3.webp');
  background-size: calc(269 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: bottom center;
  aspect-ratio: 375 / 20;
}
.accordion-item-desc-footer {
  width: 100%;
  margin: 0;
  padding: 0;
  background-image: url('../assets/image/year26-qz/frame-3.webp');
  background-size: calc(331 / 375 * 100%);
  background-repeat: no-repeat;
  background-position: bottom center;
  aspect-ratio: 375 / 30;
}
.score-title {
  font-size: 20px;
}
.starbox {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  padding: 5px 0;
}
.desc-item-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
}
.desc-item-keyword {
  font-size: 16px;
  line-height: 1.75;
}
.desc-item-main {
  font-size: 14px;
  line-height: 1.75;
}

.text-c-1 {
  color: #ffcf8c;
}
.text-c-2 {
  color: #e39557;
}
.text-c-3 {
  color: #fff0db;
}
.text-c-4 {
  color: #ffb64f;
}
.text-c-5 {
  color: #a60a0d;
}

.text-bolder {
  font-weight: 900;
}
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-justify {
  text-align: justify;
}
</style>
